"use client"

import { MarketingHeader } from "@/components/platform/MarketingHeader"
import { CareerLogo } from "@/components/max/CareerLogo"
import { ThemeToggle } from "@/components/sales/ThemeToggle"
import { GlobalSearch } from "@/components/max/GlobalSearch"
import { CAREERS_MAX_W } from "@/lib/career/layout"

// SignalMax Careers marketing header. Thin config over the shared MarketingHeader
// container: careers brand, nav, funnel CTA, and a session-aware CTA so signed-in
// visitors jump to their feed. Theme-toggle slot is filled (careers is themeable);
// the container renders it far right, per design. Used on every public careers
// marketing page (landing, pricing, FAQ, tester).
export function CareersHeader() {
  return (
    <MarketingHeader
      brand={<CareerLogo variant="wordmark" height={58} />}
      brandHref="/"
      brandLabel="SignalMax Careers"
      nav={[
        { href: "/#how-it-works", label: "How it works" },
        { href: "/intelligence", label: "Intelligence" },
        { href: "/guides", label: "Guides" },
        { href: "/pricing", label: "Pricing" },
        { href: "/faq", label: "FAQ" },
      ]}
      signIn={{ href: "/login", label: "Sign in" }}
      cta={{ href: "/try", label: "Find my internships" }}
      authedCta={{ href: "/feed", label: "Open my feed" }}
      search={<GlobalSearch />}
      themeToggle={<ThemeToggle />}
      maxWidth={CAREERS_MAX_W}
    />
  )
}
